import { message } from "antd";
import {
  BROKEN_LINK,
  EARN_CASHBACK,
  HOLISTIC_SKINCARE,
  LINKED_ACCOUNT,
  MISSING_SKINCARE,
  SKINCARE_STEPS,
} from "../constants/url";
import { catchErrors } from "../utils/catchErrors";
import { genericApiCall, getApiCall } from "../utils/servicesBaseUtil";
import { getEncodedParams } from "../utils/generateFormData";

export const getHolisticSkincareApi = ({ finalCallback, successCallback }) => {
  return (dispatch) => {
    let url = HOLISTIC_SKINCARE;
    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const getSkincareStepsApi = ({ finalCallback, successCallback }) => {
  return (dispatch) => {
    let url = SKINCARE_STEPS;
    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const getMissingSkincareApi = ({ finalCallback, successCallback }) => {
  return (dispatch) => {
    let url = MISSING_SKINCARE;
    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const notifyBrokenLinkApi = ({
  finalCallback,
  successCallback,
  data,
}) => {
  return (dispatch) => {
    let url = BROKEN_LINK;
    let formData = getEncodedParams(data);
    genericApiCall({
      url: url,
      method: "POST",
      data: formData,
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
          message.success(responseJson?.message);
        } else {
          message.error(responseJson?.message ?? "Notification failed");
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const getEarnCashbackApi = ({ finalCallback, successCallback }) => {
  return (dispatch) => {
    let url = EARN_CASHBACK;
    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const linkedAccountApi = ({ finalCallback, successCallback, data }) => {
  return (dispatch) => {
    let url = LINKED_ACCOUNT;
    let formData = getEncodedParams(data);
    genericApiCall({
      url: url,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson);
          message.success(responseJson?.message);
        } else {
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
        message.error(error?.message);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
